import { render } from "./Expire.vue?vue&type=template&id=39676f98&scoped=true"
import script from "./Expire.vue?vue&type=script&lang=js"
export * from "./Expire.vue?vue&type=script&lang=js"

import "./Expire.vue?vue&type=style&index=0&id=39676f98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39676f98"]])

export default __exports__